<template>
    <EChart :options="chartData" card :header="$t('averagePrice')" :tooltip="$t('tooltipNewReportIsCreated')" :loading="request.getLoading()" />
</template>



<script>
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'AveragePrice',
        components: {
            EChart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestData1,
            };
        },
        computed: {
            data() {
                return this.parentComponent.data;
            },
            chartData() {
                if (!this.data?.length) return { series: [] };

                const aggregates = {};

                this.data.forEach(product => {
                    const { report } = product;
                    if (!report) return;

                    Object.entries(report).forEach(([store, storeData]) => {
                        // Jeśli nie mamy żadnych danych cenowych, pomijamy
                        if (storeData.min === null && storeData.max === null) return;

                        // Obliczamy średnią dla danego produktu na podstawie wartości 'avg' z tablicy chart
                        const validAvgValues = storeData.chart.filter(({ avg }) => avg !== null).map(({ avg }) => avg);
                        const productAvg = validAvgValues.length > 0 ? validAvgValues.reduce((sum, value) => sum + value, 0) / validAvgValues.length : null;

                        // Inicjujemy agregację dla sklepu, jeśli jeszcze nie istnieje
                        if (!aggregates[store]) {
                            aggregates[store] = { mins: [], avgs: [], maxs: [] };
                        }
                        if (storeData.min !== null) aggregates[store].mins.push(storeData.min);
                        if (productAvg !== null) aggregates[store].avgs.push(productAvg);
                        if (storeData.max !== null) aggregates[store].maxs.push(storeData.max);
                    });
                });

                const calcAverage = arr => (arr.length ? arr.reduce((a, b) => a + b, 0) / arr.length : null);

                const result = {
                    tooltip: {
                        trigger: 'axis',
                        valueFormatter: value => this.$format.currency(value),
                    },
                    xAxis: {
                        type: 'category',
                        data: [],
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: val => this.$format.currency(val, null, null, 0),
                        },
                    },
                    series: [
                        {
                            name: this.$t('averageMinimumPrice'),
                            type: 'scatter',
                            symbolSize: 8,
                            itemStyle: { color: '#ef4444' },
                            data: [],
                        },
                        {
                            name: this.$t('averagePrice'),
                            type: 'scatter',
                            symbolSize: 10,
                            itemStyle: { color: '#3b82f6' },
                            data: [],
                        },
                        {
                            name: this.$t('averageMaximumPrice'),
                            type: 'scatter',
                            symbolSize: 8,
                            itemStyle: { color: '#22c55e' },
                            data: [],
                        },
                    ],
                };

                if (!Object.entries(aggregates).length) return { series: [] };

                Object.entries(aggregates).forEach(([store, { mins, avgs, maxs }]) => {
                    result.xAxis.data.push(store);
                    result.series[0].data.push(calcAverage(mins));
                    result.series[1].data.push(calcAverage(avgs));
                    result.series[2].data.push(calcAverage(maxs));
                });

                return result;
            },
        },
    };
</script>
